module.exports = __webpack_public_path__ + "static/media/logo.ff679c38.png";